import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { minimalSponsorFragmentString } from '../../fragments/__generated__/MinimalSponsorFragment'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import purchaseProductRawString from '../PurchaseProduct.graphql'

const purchaseProductString = [
  purchaseProductRawString,
  accountFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
  minimalSponsorFragmentString,
  stripeSubscriptionString,
  subscriptionMetadataString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  userSettingsFragmentString,
  expenseReloadString,
  bankAccountFragmentString,
  addressFragmentString,
].join('\n\n')

export type PurchaseProductData = {
  purchaseProduct: {
    purchased: Maybe<boolean>
    error: Maybe<string>
    account: AccountFragment
  }
}

export type PurchaseProductVariables = {
  orderId: string
  stripeToken?: Maybe<string>
}

export type PurchaseProduct = Operation<
  PurchaseProductData,
  PurchaseProductVariables
>

export const PurchaseProduct = ({
  orderId,
  stripeToken,
}: PurchaseProductVariables): PurchaseProduct => ({
  query: purchaseProductString,
  variables: {
    orderId,
    stripeToken,
  },
})
